import { Card, Col, Container, Row } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { SpotSvg } from '@enterprise/spot';
import { RightSidebar } from '../../../../layout/main/rightSidebar';
import { Trans } from 'react-i18next';
import { useStores } from '../../../../hooks';

interface PageProps {
    applyPreset: any;
    close: any;
}

const PresetsSidebar = observer(function PresetsSidebarComponent(props: PageProps) {
    const { applyPreset, close } = props;
    const {
        domain: { itemsPageStore },
    } = useStores();

    const createHeader = () => {
        return (
            <Container className="presets-sidebar">
                <Row>
                    <Col xs={12} className="spot-typography__text--body">
                        <h4 className="title">
                            <Trans i18nKey="presetsSidebar:savedSearches">Saved Searches</Trans>
                        </h4>
                    </Col>
                </Row>
            </Container>
        );
    };

    const createPresetDescription = (preset) => {
        const deletePreset = () => itemsPageStore.deletePreset(preset);
        const onApplyPreset = () => applyPreset(preset.id);
        return (
            <>
                <Card>
                    <Card.Body>
                        <Container>
                            <Row>
                                <Col xs={8} className="spot-typography__text--body">
                                    <span>{preset.name}</span>
                                </Col>
                                <Col xs={3} className="spot-typography__text--body">
                                    <a href="#" className="spot-link" style={{ float: 'right' }} onClick={onApplyPreset}>
                                        <Trans i18nKey="presetsSidebar:applySearch">Apply Search</Trans>
                                    </a>
                                </Col>
                                <Col xs={1} className="spot-typography__text--body" style={{ textAlign: 'right' }}>
                                    <p>
                                        <a href="#" className="spot-link">
                                            <SpotSvg onClick={deletePreset} icon="delete" className="spot-link__icon" />
                                        </a>
                                    </p>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>
            </>
        );
    };

    return (
        <RightSidebar close={close} header={createHeader} modalBodyStyle={{ margin: '0px', padding: '0px' }} isSmall={true}>
            <div>
                {itemsPageStore.presets.map((preset) => {
                    return (
                        <Row key={preset.id} className="align-items-center justify-content-center">
                            <Col xs={12}>{createPresetDescription(preset)}</Col>
                        </Row>
                    );
                })}
            </div>
        </RightSidebar>
    );
});

export default PresetsSidebar;
